<style lang="less">
.loading-more-container {
  height: 50px;
  align-items: center;
  justify-content: center;
  .load-icon {
      width: 20px;
      height: 20px;
    &::before {
      font-size: 20px;
      color: var(--black);
    }
  }
  .load-text {
      font-size: 14px;
      color: #666;
      margin-left: 5px;
  }
  .no-more {
    width: 100%;
    align-items: center;
    justify-content: center;
    &::before,
    &::after {
      width: 25%;
      height: 1px;
      margin: 0 15px;
      content: " ";
      background-color: #ddd;
    }
  }

}
</style>

<template>
  <div class="loading-more-container flex col">
      <div class="flex row" v-if="loadingMore">
          <i class="el-icon-loading load-icon" ></i>
          <span class="load-text">正在加载</span>
      </div>
    
    <div class="padding text-lg flex flex-cc no-more" v-if="!loadingMore && !hasMore">
      <span class="text-sm text-gray">没有更多啦</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ec-loading-more",
  props: {
    loadingMore: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default: null
    }
  },
  computed: {
    hasMore() {
      if (!this.pagination) {
        return true
      }
      const { haxNextPage, currentPage } = this.pagination
      return haxNextPage && currentPage > 0
    }
  }
}
</script>